<template>
  <div :class="$style.item">
    <a @click.prevent.stop="removeItem(index)" :class="$style.trash">
      <i class="fas fa-trash-alt"></i>
    </a>
    <div v-if="item.types && item.types.length" :class="$style.itemTypes">
      {{ `${productTypeLabel} ${item.types.join(", ")}` }}
    </div>
    <div v-if="item.title" :class="$style.itemTitle">
      {{ item.title }}
      <div v-if="item.subTitle">
        {{ item.subTitle }}
      </div>
    </div>
    <div
      v-if="item.downloads && countries && countries.length"
      :class="$style.flags"
    >
      <CountryDownloadBox
        :countries="countries"
        :section="item.section"
        :title="item.title"
        :types="item.types"
        :labels="{ ebook: 'Ebook', pdf: 'PDF', wishList: 'Wishlist' }"
        :context="countryDownloadBoxContext"
      />
    </div>
    <div v-if="item.section" :class="$style.section">
      {{ item.section }}
    </div>
  </div>
</template>

<script>
import CountryDownloadBox from "../CountryDownloadBox/CountryDownloadBox";
import { CountryDownloadBoxContext } from "../../globals/constants/download";

export default {
  name: "WishListItem",
  components: {
    CountryDownloadBox
  },
  props: {
    countries: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: () => null
    },
    productTypeLabel: {
      type: String,
      default: () => ""
    }
  },
  methods: {
    removeItem(index) {
      this.$emit("removeItem", index);
    }
  },
  data() {
    return {
      countryDownloadBoxContext: CountryDownloadBoxContext.WISHLIST
    };
  }
};
</script>

<style module lang="scss">
@import "./WishListItem.scss";
</style>
